import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {toJS} from 'mobx';
import { Document } from 'firestorter';
import {
  Form,
  Spin,
  Button,
  Input,
  Tag,
  Icon,
  Divider,
  Avatar,
  Select,
  DatePicker,
  Switch,
  Rate,
  notification,
  Collapse,
  Checkbox
} from "antd";

import moment from 'moment';

const Panel = Collapse.Panel;
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;

class requestForm extends Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.initialProps = Object.assign(this.props.request || {}, {inputVisible: false, inputValue: null, usersEmail:{}});
    this.state = Object.assign(this.props.request || {}, {inputVisible: false, inputValue: null, usersEmail:{}});
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillReceiveProps(nextProps){
    console.log('componentWillReceiveProps', nextProps);
    if(nextProps.request){
      console.log("HELLLO",this.initialProps);
      console.log('nextProps', nextProps);
      this.setState(Object.assign(this.initialProps, nextProps.request));
      console.log('statttt',this.state);
      if(this.state.author){
        this.getUser(this.state.author, "getAuthor");
      }
      if(this.state.nurse){
        this.getUser(this.state.nurse.id, "getNurse");
      }
    }
  }
  componentWillUnmount(){
    this.setState(null);
  }
  async getUser(userId, field) {
      var userDocument = new Document("users/" + userId, {
        mode: "off"
      });
      const user = await userDocument.fetch();
      if(user.data) {
        console.log("user ",user.data);
        this.setState({[field]: user.data})
      }
    }
  // componentDidUpdate(prevProps,prevState, snapshot){
  //   if(!!this.props.disabled && this.state != this.initialProps){
  //     this.setState(Object.assign(this.props.request || {}, {inputVisible: false, inputValue: null, usersEmail:{}}));
  //   }
  //   console.log('prevProps', prevProps.request);
  //   console.log('prevState', prevState);
  // }
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    const clone = Object.assign(this.state)
    delete clone.inputVisible;
    delete clone.inputValue;
    delete clone.loading;
    delete clone.disabled;
    delete clone.usersEmail;
    delete clone.getAuthor;
    delete clone.getNurse;

    console.log('CLONE is:', clone);
    console.log('CLONE DATE', );
    if(!(clone.startTime instanceof Date) || !(clone.endTime instanceof Date)) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Date mal formatée"
      })
      return false;
    }
    try {
      await this.props.submit(clone);
    } catch(e) {
      console.log('Error', e.message);
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: e.message
      })
      this.setState({loading: false});
      return false;
    }
    this.setState({loading: false});
    notification.success({
      message: "Opération réussie"
    })
    this.props.closeModal ? this.props.closeModal() : null;
    this.setState(this.props.request ? {...this.props.request} : {...Object.keys(this.state).forEach(v => this.state[v] = null)} )
  }

  taskOptions = [
    'Ménage',
    'Courses',
    'Entretien du linge',
    'Promenade',
    'Repas',
    'Aide à la toilette',
    'Aide au lever',
    'Aide au coucher',
    'Compagnie de jour',
    'Compagnie de nuit'
  ];
  render() {
    console.log('RE RENDER FORM')


    // const authorInfo = this.state.getAuthor ? this.state.getAuthor.firstname + " " + this.state.getAuthor.lastname + " (" + this.state.author + ")": "";
    // const nurseInfo = this.state.getNurse ? this.state.getNurse.firstname + " " + this.state.getNurse.lastname + " (" + this.state.nurse.id +")": "";
    const authorInfo = this.state.getAuthor ? this.state.getAuthor.firstname + " " + this.state.getAuthor.lastname: "";
    const nurseInfo = this.state.getNurse ? this.state.getNurse.firstname + " " + this.state.getNurse.lastname: "";
    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <Form layout={!!this.props.disabled ? "horizontal" : "vertical"} onSubmit={this.handleSubmit} style={{ maxWidth: 800 }} className={!!this.props.disabled? 'readOnlyForm': null}>
      {/*    <FormItem label="Email">
            <Input
              value={this.state.email || ''}
              disabled={!!this.props.disabled}
              onChange={event => this.setState({email: event.target.value })}
              />
          </FormItem>
          */}

          <FormItem label="Client">
                <Input
                  value={this.props.disabled ? authorInfo || "Chargement..." : this.state.author || ''}
                  disabled={!!this.props.disabled}
                  onChange={event => this.setState({author: event.target.value })}
                  />
                  {/*this.props.disabled*/ true ? <Input
                    value={this.state.getAuthor ? this.state.getAuthor.email : "Chargement..."}
                    disabled={true}
                    /> : null }
                    { /*this.props.disabled*/ true ? <Input
                      value={this.state.getAuthor ? this.state.getAuthor.phonenumber : "Chargement..."}
                      disabled={true}
                      /> : null }
          </FormItem>

          <FormItem label="Intervenant">
                <Input
                  value={this.props.disabled ? nurseInfo || "Chargement..." : (this.state.nurse ? this.state.nurse.id || '' : "")}
                  disabled={!!this.props.disabled}
                  onChange={event => this.setState({nurse: {id: event.target.value} })}
                  />
                  {/*this.props.disabled*/ true? <Input
                    value={this.state.getNurse ? this.state.getNurse.email : "Chargement..."}
                    disabled={true}
                    /> : null }
                    {/*this.props.disabled*/ true ? <Input
                      value={this.state.getNurse ? this.state.getNurse.phonenumber : "Chargement..."}
                      disabled={true}
                      /> : null }
          </FormItem>

          {/*<FormItem label="Code Postal">
                <Input
                  value={this.state.getAuthor ? this.state.getAuthor.zipCode : "Chargement..."}
                  disabled={true}
                  />
          </FormItem>*/}
          <FormItem label="Début">
            <DatePicker showTime disabled={!!this.props.disabled} format="YYYY-MM-DD HH:mm" value={moment(this.state.startTime) || null} onChange={value => this.setState({startTime: value ? value.toDate() : null})} />
          </FormItem>
          <FormItem label="Fin">
            <DatePicker showTime disabled={!!this.props.disabled} format="YYYY-MM-DD HH:mm" value={moment(this.state.endTime) || null} onChange={value => this.setState({endTime: value ? value.toDate() : null})} />
          </FormItem>
          <FormItem label='Tâches'>
            <CheckboxGroup disabled={!!this.props.disabled} options={this.taskOptions} value={toJS(this.state.tasks)} onChange={(values) => {
                console.log('values', values);
                this.setState({tasks: values});
              }} />
          </FormItem>
          {this.props.children}
          <FormItem label="Remboursée? ">
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={!!this.state.refund && this.state.payment !== 'cancelled'} onChange={value => this.setState({refund: value})} />
          </FormItem>
          <FormItem label="Annulée? ">
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={!!this.state.isCancelled} onChange={value => this.setState({isCancelled: value ? 'admin' : false})} />
          </FormItem>
          {this.state.cancelTime && this.state.isCancelled ? <FormItem label="Horaire d'annulation ">
            <Input
              value={this.state.cancelTime ?  moment(this.state.cancelTime).format("Do MMMM YYYY [à] HH[h]mm") : null}
              disabled={true}
              />
          </FormItem> : null}
          {
            this.state.isCancelled && this.state.isCancelled !== "admin" ?
            <FormItem label="Origine de l'annulation : ">
              <Input
                value={this.state.isCancelled == "nurse.id" ? "Intervenant" : this.state.isCancelled == "author" ? "Client" : "Autre"}
                disabled={true}
                />
            </FormItem>
            : null
          }
          {this.state.cancelReason || !this.props.disabled ?
            <FormItem label="Motif d'annulation (opt. à renseigner à l'enregistrement de l'annulation)? ">
              <Select disabled={!!this.props.disabled} defaultValue={this.state.cancelReason || ""} style={{ width: 280 }} onChange={(value) => {this.setState({cancelReason: value})}}>
                    <Option value="">Non précisé</Option>
                    <Option value="Congés">Congé</Option>
                    <Option value="Arrêt maladie">Arrêt maladie</Option>
                    <Option value="Congés maternité">Congés maternité</Option>
                    <Option value="Jour férié sauf 1er mai">Jour férié sauf 1er mai</Option>
                    <Option value="1er mai">1er mai</Option>
                    <Option value="Congés exceptionnels conventionnels">Congés exceptionnels conventionnels</Option>
                  </Select>
            </FormItem> : null}
          <FormItem label="Payée? ">
            <Switch disabled={true} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={!!this.state.payment && this.state.payment !== 'cancelled'} onChange={value => this.setState({payment: value})} />
              {this.state.payment ? <Input
                value={this.state.payment}
                disabled={true}
                /> : null }
          </FormItem>
          {!!this.props.disabled ? null :
          <FormItem style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
            <a onClick={() => {this.props.closeModal ? this.props.closeModal() : null;  this.props.switchFunc ? this.props.switchFunc() : null}} style={{margin: 25}}><u>Annuler</u></a>
            <Button type="primary" size='large' htmlType="submit" loading={this.state.loading}>Enregistrer</Button>
          </FormItem> }
        </Form>

      </div>
    );
  }
}
const RequestForm = Form.create()(requestForm);
export default RequestForm;



// WEBPACK FOOTER //
// ./src/RequestForm.js